export default {
  NATSession: 'NAT会话',
  SearchPlaceholder: '搜索源IP/目标域名/目标IP',
  GatewayBranch: '网关/分支',
  BeforeConversion: '转换前',
  ColumnLabel1: '源IP/端口—>目标域名/IP/端口',
  AfterConversion: '转换后',
  SNAT: '源地址转换',
  DNAT: '目标地址转换',
  SNATandDNAT: '源目地址转换',
  AcquisitionDevice: '采集设备',
}